export default "__VITE_ASSET__Dou9C0j4__"